import { deleteItemFromCollection } from "directus/src/operations";

export async function deleteMeeting({ meetingId }) {
    try {
        const query = {
            fields: ["id"],
        };
        const data = await deleteItemFromCollection("calendar_events", meetingId, query);
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}